/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Move_UpInputs */

const en_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

const fr_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monter en gamme`)
};

const de_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsteigen`)
};

const it_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostarsi verso l'alto`)
};

const ru_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поднимитесь выше`)
};

const es_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir`)
};

const zh_cn2_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向上`)
};

const ja_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上へ進む`)
};

const hi_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बढ़ाना`)
};

const pt_pt2_audio_embed_export_output_move_up = /** @type {(inputs: Audio_Embed_Export_Output_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suba`)
};

/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Audio_Embed_Export_Output_Move_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_move_up = /** @type {((inputs?: Audio_Embed_Export_Output_Move_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Move_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_move_up(inputs)
	if (locale === "de") return de_audio_embed_export_output_move_up(inputs)
	if (locale === "it") return it_audio_embed_export_output_move_up(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_move_up(inputs)
	if (locale === "es") return es_audio_embed_export_output_move_up(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_move_up(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_move_up(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_move_up(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_move_up(inputs)
	return en_audio_embed_export_output_move_up(inputs)
});